import { ReactNode } from "react";

interface AssessmentLayoutProps {
  children: ReactNode;
  companyName?: string;
  companyLogo?: string;
  className?: string;
}

export function AssessmentLayout({ 
  children, 
  companyName = "Company", 
  companyLogo,
  className = ""
}: AssessmentLayoutProps) {
  const getCompanyInitials = (name: string | undefined) => {
    if (!name || typeof name !== 'string') {
      return 'CO'; // Default initials
    }
    return name
      .split(' ')
      .map(word => word.charAt(0).toUpperCase())
      .join('')
      .slice(0, 2);
  };

  return (
    <div className={`min-h-screen bg-background flex flex-col ${className}`}>
      {/* Company Header - At Top */}
      <div className="w-full border-b border-border bg-background/80 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center gap-3">
            {companyLogo ? (
              <img 
                src={companyLogo} 
                alt={`${companyName} logo`}
                className="h-8 w-auto max-w-20 object-contain"
              />
            ) : (
              <div className="h-8 w-8 bg-primary/10 rounded flex items-center justify-center">
                <span className="text-sm font-bold text-primary">
                  {getCompanyInitials(companyName)}
                </span>
              </div>
            )}
            <h2 className="text-lg font-semibold text-foreground">
              {companyName}
            </h2>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1">
        {children}
      </div>

      {/* Footer - Powered by Testera */}
      <div className="border-t border-border bg-muted/30">
        <div className="max-w-7xl mx-auto px-6 py-3">
          <p className="text-center text-sm text-muted-foreground flex items-center justify-center gap-2">
            Powered by <img src="/lovable-uploads/e7e0cd62-757f-4e57-b3bf-42cffdc8d843.png" alt="Testera" className="h-4 w-auto" /> <span className="font-medium text-foreground">Testera</span>
          </p>
        </div>
      </div>
    </div>
  );
}